import React, { useState,useEffect } from "react";
import tw, { styled } from "twin.macro";
import { useNavigate } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import { doc, getDoc, updateDoc ,getDocs,query,where,collection} from "firebase/firestore";
import { db, auth } from "../../../../FireBaseConfig";
import { toast,Toaster } from "react-hot-toast";
import { Modal, Button as AntButton, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";
const { Text } = Typography;

const CustomModal = styled(Modal)`
    .ant-modal-content {
        border-radius: 20px;
        padding: 30px;
        background: linear-gradient(135deg, #f0f4ff, #ffffff);
        box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
    }
    .ant-modal-header {
        background: none;
        border-bottom: none;
        text-align: center;
        padding: 0;
    }
    .ant-modal-title {
        font-size: 24px;
        font-weight: bold;
        color: #333;
    }
    .ant-modal-close {
        top: 20px;
        right: 20px;
    }
    .ant-modal-body {
        font-size: 18px;
        line-height: 1.6;
        text-align: center;
        padding: 20px 0;
    }
    .ant-modal-footer {
        display: none;
    }
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    gap: 125px;
margin-right: 100px;
    margin-top: 40px;
    margin-bottom: 40px;
`;
const ButtonContainerModal = styled.div`
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-top: 20px;
`;
const StyledButton = styled(AntButton)`
    height: 45px;
    font-size: 16px;
    font-weight: bold;
    padding: 0 20px;
    border-radius: 10px;
    transition: all 0.3s ease;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);

    &:hover {
        transform: translateY(-2px);
    }
`;

const PrimaryButton = styled(StyledButton)`
    background: #0ABD19;
    color: white;
    border: none;

    margin-bottom: 10px;
    justify-content: start;
    &:hover {
        background: #45a049;
    }
`;

const DangerButton = styled(StyledButton)`
  background: #f44336;
  color: white;
  border: none;

  &:hover {
    background: #e53935;
  }
`;

const Buttons = ({
                     totalCostUSD,
                     totalCostKZT,
                     insuranceAmount,
                     customDutyKZT,
                     insuranceIncluded,
                     parcelId, // ID посылки
                     servicesIds, // Массив ID услуг
                     deliveryCost, // Приходит в долларах
                     deliveryCosts, // Стоимость доставки CDEK в KZT
                     deliveryPointCode, // Код ПВЗ CDEK
                     deliveryPointAddress, // Адрес ПВЗ CDEK
                     tariffCode, // Код тарифа CDEK
                 }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [insufficientFunds, setInsufficientFunds] = useState(false);
    const [missingAmount, setMissingAmount] = useState(0);
    const navigate = useNavigate();
    const [exchangeRate, setExchangeRate] = useState(450); // Курс доллара к тенге (по умолчанию)


    // Получение курса валют из API
    useEffect(() => {
        const fetchExchangeRate = async () => {
            try {
                const response = await fetch(`https://open.er-api.com/v6/latest/USD`);
                const data = await response.json();
                if (data && data.rates && data.rates.KZT) {
                    setExchangeRate(data.rates.KZT);
                } else {
                    console.warn('Exchange rate data not available');
                }
            } catch (error) {
                console.error('Error fetching exchange rate:', error);
            }
        };

        fetchExchangeRate();
    }, []);

    const deliveryCostKZT = Math.round(Number(deliveryCost) * exchangeRate);

    const totalKZT =
        Math.round(Number(insuranceAmount) || 0) +
        (deliveryCostKZT || 0) +
        (Number(deliveryCosts) || 0);





    const handlePayWithBalance = async () => {
        console.log('💳 Starting payment with balance...');
        console.log('   Total amount to pay:', totalKZT, 'KZT');
        console.log('   Parcel ID:', parcelId);

        try {
            const user = auth.currentUser;
            if (!user) throw new Error("Пользователь не авторизован");

            const userId = user.uid;
            console.log('👤 User ID:', userId);

            const q = query(collection(db, "balances"), where("userId", "==", userId));
            const querySnapshot = await getDocs(q);

            if (querySnapshot.empty) {
                console.error('❌ Balance document not found for user:', userId);
                throw new Error("Баланс пользователя не найден");
            }

            const userBalanceDoc = querySnapshot.docs[0].ref;
            const balanceSnapshot = await getDoc(userBalanceDoc);

            if (!balanceSnapshot.exists()) {
                console.error('❌ Balance document does not exist');
                throw new Error("Баланс пользователя не найден");
            }

            const userBalance = balanceSnapshot.data().balance || 0;
            console.log('💰 Current balance:', userBalance, 'KZT');
            console.log('💸 Amount to deduct:', totalKZT, 'KZT');

            if (userBalance < totalKZT) {
                const shortage = totalKZT - userBalance;
                console.warn('⚠️ Insufficient funds!');
                console.warn('   Current:', userBalance, 'KZT');
                console.warn('   Required:', totalKZT, 'KZT');
                console.warn('   Short by:', shortage, 'KZT');
                toast.error("Недостаточно средств на балансе.");
                navigate("/PaymentSuccess", { state: { success: false, parcelId } });
                return;
            }

            // ✅ СНАЧАЛА обновляем статус посылки и услуг
            console.log('📝 Updating parcel and services status...');
            const parcelUpdated = await updateParcelStatus();
            const servicesUpdated = await updateServicesStatus();

            if (!parcelUpdated) {
                console.error('❌ Failed to update parcel status');
                toast.error("Не удалось обновить статус посылки. Оплата отменена.");
                navigate("/PaymentSuccess", { state: { success: false, parcelId } });
                return;
            }

            // ✅ ТОЛЬКО ПОСЛЕ успешного обновления статуса списываем деньги
            const newBalance = userBalance - totalKZT;
            console.log('📊 Deducting from balance...');
            console.log('   Before:', userBalance, 'KZT');
            console.log('   After:', newBalance, 'KZT');

            await updateDoc(userBalanceDoc, { balance: newBalance });
            console.log('✅ Balance updated successfully!');

            console.log('✅ Payment completed successfully!');
            console.log('   Parcel status updated to: Оплачено');
            console.log('   New balance:', newBalance, 'KZT');
            toast.success("Оплата успешно завершена!");
            navigate("/PaymentSuccess", { state: { success: true, parcelId } });

        } catch (error) {
            console.error('❌ Payment error:', error);
            console.error('   Error message:', error.message);
            toast.error("Произошла ошибка при оплате.");
            navigate("/PaymentSuccess", { state: { success: false, parcelId } });
        }
    };



    const updateParcelStatus = async () => {

        if (!parcelId) {

            return false;
        }
        try {
            // Поиск документа с совпадением по полю 'id'
            const querySnapshot = await getDocs(
                query(collection(db, "parcels"), where("id", "==", parcelId))
            );

            if (querySnapshot.empty) {

                return false;
            }

            // Получение реального ID документа
            const documentRef = querySnapshot.docs[0].ref;

            // Обновляем документ по реальному ID с данными CDEK
            const updateData = {
                status: "Оплачено",
                insuranceIncluded: insuranceIncluded,
                insuranceAmount: insuranceIncluded ? insuranceAmount : 0,
                cdekDeliveryPointCode: deliveryPointCode || null, // Код ПВЗ для CDEK
                cdekDeliveryPointAddress: deliveryPointAddress || null, // Адрес ПВЗ
                cdekTariffCode: tariffCode || 136, // Код тарифа CDEK
                cdekDeliveryCost: deliveryCosts || 0, // Стоимость доставки CDEK
            };

            console.log('💾 Saving CDEK data to parcel:', {
                deliveryPointCode,
                deliveryPointAddress,
                tariffCode,
                deliveryCosts
            });

            await updateDoc(documentRef, updateData);

            toast.success("Статус посылки обновлен.");
            return true;
        } catch (error) {

            return false;
        }
    };





    const handlePayWithCard = async () => {
        try {
            navigate("/PaymentForm", { state: { amount: totalKZT, parcelId, servicesIds } });
        } catch (error) {
            console.error('Error navigating to payment form:', error);
        }
    };



    const updateServicesStatus = async () => {
        if (!servicesIds || !Array.isArray(servicesIds)) return true; // нет услуг — считаем успех

        try {
            const updatePromises = servicesIds.map(async (serviceId) => {
                const querySnapshot = await getDocs(
                    query(collection(db, "applications"), where("id", "==", serviceId))
                );

                if (querySnapshot.empty) return null;

                const documentRef = querySnapshot.docs[0].ref;
                await updateDoc(documentRef, { status: "Оплачено" });

                return true;
            });

            const results = await Promise.all(updatePromises);

            // Проверяем, хотя бы одна ли услуга была успешно обновлена
            const hasSuccess = results.some((res) => res === true);

            if (hasSuccess) {
                toast.success("Все услуги успешно обновлены.");
            }

            return true; // всегда возвращаем успех, даже если часть услуг не найдена
        } catch (error) {
            return false;
        }
    };





    const handleCancel = () => {
        toast("Оплата отменена.", {
            icon: "🚫",
            style: {
                borderRadius: "8px",
                background: "#f5222d",
                color: "#fff",
            },
        });
        navigate("/IncomingParcels");
    };
    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    useEffect(() => {
        if (parcelId) {
            localStorage.setItem("currentParcelId", parcelId);
        }
    }, [parcelId]);

    const storedParcelId = localStorage.getItem("currentParcelId");
    return (
        <>
            <ButtonContainer>
                <PrimaryButton onClick={() => setIsModalOpen(true)}>Оплатить</PrimaryButton>
                <DangerButton onClick={handleCancel}>Отмена</DangerButton>
            </ButtonContainer>

            <CustomModal
                title="Выберите способ оплаты"
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                closeIcon={<CloseOutlined style={{ fontSize: "20px", color: "#888" }} />}
            >
                <Text strong style={{ fontSize: "18px" }}>
                    Итоговая сумма: <span style={{ fontWeight: "bold" }}>{Math.round( totalKZT)} ₸</span>
                </Text>
                <ButtonContainerModal>
                    <DangerButton onClick={handleCancel}>Отмена</DangerButton>
                    <PrimaryButton onClick={handlePayWithBalance}>С баланса</PrimaryButton>
                    <PrimaryButton onClick={handlePayWithCard}>С карты</PrimaryButton>
                </ButtonContainerModal>
            </CustomModal>
        </>
    );
};

export default Buttons;

